'use strict';

import React from 'react';
import { connect } from 'react-redux';
import Button from 'components/clarity-ui/inputs/button';
import Loader from 'components/clarity-ui/components/loader';
import entityRecommenderSelector from './entityRecommender.selector';
import EntityRecommenderPageHeader from './entityRecommenderPageHeader.component';
import EntityHelpers from './entityRecommender.helper';
import EntityState from './entityRecommender.state';
import InputField from 'components/clarity-ui/inputs/inputField/inputField';
import PageNotification from 'components/clarity-ui/components/pageNotification';
import QueryBuilder from './queryBuilder/queryBuilder.component';
import RecommendationsTable from './queryResults/recommendationsTable.component';
import SectionHeader from 'components/clarity-ui/components/sectionHeader';
import WebPagesTable from './entityWebPagesTable.component';
import _ from 'lodash';

class EntityRecommenderComponent extends React.Component {

  constructor () {
    super();
    this.handleSuggestionsAutocompleteOnChange = _.debounce(this.handleSuggestionsAutocompleteOnChange, 1000);
  }

  componentWillMount () {
    this.setState(EntityState.getNewStateObject());
  }

  componentDidUpdate (prevProps, prevState) {
    const newState = EntityState.getComponentState(prevProps, prevState, this.state, this.props);

    if (!_.isEmpty(newState)) {
      this.setState(newState);
    }
  }

  handleAddRuleButtonOnClick (synthEvent) {
    const node = EntityHelpers.getTreeObjectBySynthEvent(synthEvent, this.state.queryTree);
    node.children.push(EntityHelpers.createNewRule())
    this.setState({queryTree: this.state.queryTree});
  }

  handleAddGroupButtonOnClick (synthEvent) {
    const node = EntityHelpers.getTreeObjectBySynthEvent(synthEvent, this.state.queryTree);
    node.children.push(EntityHelpers.createNewGroup(true))
    this.setState({queryTree: this.state.queryTree});
  }

  handleDeleteButtonOnClick (synthEvent) {
    const elemName = synthEvent.currentTarget.closest('.EntityShowCase').getAttribute('name');
    EntityHelpers.deleteObjectFromTree(elemName, this.state.queryTree);
    this.setState({queryTree: this.state.queryTree});
  }

  handleButtonGroupOnClick (synthEvent) {
    const node = EntityHelpers.getTreeObjectBySynthEvent(synthEvent, this.state.queryTree);
    node.connector = synthEvent.currentTarget.value;
    this.setState({queryTree: this.state.queryTree});
  }

  handleSuggestionsAutocompleteKeyPress (synthEvent) {
    if (synthEvent.key === 'Enter' && !this.state.loadingRecommendations) {
      const suggestionValue = synthEvent.currentTarget.value,
            node = EntityHelpers.getTreeObjectBySynthEvent(synthEvent, this.state.queryTree);
            node.value = suggestionValue;

      this.props.fetchEntitiesRecommendations(suggestionValue);
      this.setState({loadingRecommendations: true, queryTree: this.state.queryTree});
    }
  }

  handleSuggestionsAutocompleteSelect (queryRule, entityName, entityObject) {
    const node = EntityHelpers.getTreeObjectByName(queryRule.name, this.state.queryTree);
    node.value = entityObject.name;
    this.props.fetchEntitiesRecommendations(node.value);
    this.setState({queryTree: this.state.queryTree, loadingRecommendations: true});
  }

  handleSuggestionsAutocompleteOnChange (queryRule, synthEvent, value) {
    if (!this.state.loadingRecommendations) {
      const node = EntityHelpers.getTreeObjectByName(queryRule.name, this.state.queryTree);
      node.value = value;
      this.props.fetchEntitySuggestions(value);
      this.setState({queryTree: this.state.queryTree});
    }
  }

  handleExecuteButtonOnClick (queryTerm) {
    this.props.fetchQuery(queryTerm);
    this.setState({
      loading: true,
      isExecuteClicked: true
    });
  }

  handleNewClassifierOnChange (synthEvent) {
    this.setState({newClassifierName: synthEvent.currentTarget.value});
  }

  handleCreateClassifierOnClick () {
    const queryTerm = EntityHelpers.getTermFromTree(this.state.queryTree);
    this.props.saveNewClassifier(this.state.newClassifierName, queryTerm);
    this.setState({loading: true, pageNotification: {show: false, msg: '', type: '', target: ''}});
  }

  renderPageNotification (pageNotification) {
    return (
      <div className="BreakLine">
        <PageNotification type={pageNotification.type}>
          { pageNotification.msg }
        </PageNotification>
      </div>
    );
  }

  render() {
    const { queryTree, loading, loadingRecommendations, isExecuteClicked, newClassifierName, pageNotification } = this.state;
    const { entitiesSuggestion, entityRecommendations, entitiesWebPages } = this.props;
    const queryTerm = EntityHelpers.getTermFromTree(queryTree);
    const isInvalidQuery = queryTerm < 3;

    return (
      <div className="EntityList">
        <Loader loading={loading} />
        <EntityRecommenderPageHeader title="Entity Search Tool" />
        <div className="BreakLine" />
        <SectionHeader>New Label</SectionHeader>
        {
          pageNotification.show && pageNotification.target === 'newClassifier'
          ? this.renderPageNotification(pageNotification)
          : null
        }
        <div className="BreakLine">
          <div className="Grid-cell--4of6">
            <InputField
              id="classifierName"
              placeholder="Label Name"
              value={newClassifierName}
              onChange={this.handleNewClassifierOnChange.bind(this)}/>
          </div>
          <div className="Grid-cell--2of6">
            <Button
              {...EntityHelpers.getCreateClassifierButtonProps(newClassifierName, isInvalidQuery)}
              className='ElemRightAlign Medium CustomWhite WithBlue'
              onClick={this.handleCreateClassifierOnClick.bind(this)}>
              Create Label
            </Button>
          </div>
        </div>
        <div className="BreakLine" />
        <SectionHeader>Query Builder</SectionHeader>
        <div className="Grid-cell--9of12">
          <QueryBuilder
            queryTree={queryTree}
            queryTerm={queryTerm}
            entitiesSuggestion={entitiesSuggestion}
            handleAddRuleButtonOnClick={this.handleAddRuleButtonOnClick.bind(this)}
            handleAddGroupButtonOnClick={this.handleAddGroupButtonOnClick.bind(this)}
            handleDeleteButtonOnClick={this.handleDeleteButtonOnClick.bind(this)}
            handleButtonGroupOnClick={this.handleButtonGroupOnClick.bind(this)}
            handleSuggestionsAutocompleteSelect={this.handleSuggestionsAutocompleteSelect.bind(this)}
            handleSuggestionsAutocompleteOnChange={this.handleSuggestionsAutocompleteOnChange.bind(this)}
            handleSuggestionsAutocompleteKeyPress={this.handleSuggestionsAutocompleteKeyPress.bind(this)}/>
          <div className="BreakLine floatRightAlign" style={{marginBottom: 20+'px'}}>
            <Button
              className='Small CustomWhite WithBlue'
              onClick={this.handleExecuteButtonOnClick.bind(this, queryTerm)}
              disabled={isInvalidQuery}
            >
              Preview
            </Button>
          </div>
          <div className="BreakLine">
            <WebPagesTable
              isExecuteClicked={isExecuteClicked}
              entitiesWebPages={entitiesWebPages}/>
          </div>
        </div>
        <div className="Grid-cell--3of12 elementPaddingLeft">
          <RecommendationsTable
            loading={loadingRecommendations}
            entityRecommendations={entityRecommendations}/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => {
  const getFromSelector = entityRecommenderSelector;
  const stateToProps = (state) => {
    return getFromSelector(state);
  };
  return stateToProps;
}

EntityRecommenderComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(mapStateToProps)(EntityRecommenderComponent);



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityRecommender.component.jsx